export const APP_IDENTIFIER = 'general-settings';
export const APP_TEAM_NAME = 'a4t-pandora';
export const APP_SOURCE_NAME = 'generalSettings';

export const VIEW_GENERAL_SETTINGS_EXPERIENCE_NAME = 'viewGeneralSettings';
